export const getFileExtension = (file: File) => {
  const splittedFile = file.name.split('.');
  const extension = splittedFile[splittedFile.length - 1];

  return extension;
};
